import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);

  // Check the authentication status
  return inject(AuthService)
    .check()
    .pipe(
      switchMap((authenticated) => {
        // If the user is not authenticated...
        if (!authenticated) {
          // Redirect to the sign-in page, remembering where they were going.
          //
          // Built with `createUrlTree` rather than by concatenating the URL
          // into a query string: `state.url` is a whole URL, its own query
          // params and fragment included, and pasted raw its first `&` ended
          // the `redirectURL` parameter. The rest became sibling params of
          // `sign-in` and was dropped, so signing in returned the user to a
          // truncated version of the page they had asked for.
          const urlTree =
            state.url === '/sign-out'
              ? router.createUrlTree(['/sign-in'])
              : router.createUrlTree(['/sign-in'], {
                  queryParams: { redirectURL: state.url },
                });

          return of(urlTree);
        }

        // Allow the access
        return of(true);
      }),
    );
};
